import React from 'react';
import styled from 'styled-components';
import Button from 'gatsby-theme-core/src/components/button/index';

const FooterNav = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  line-height: 30px;
`;

const FooterItem = styled.li`
  a {
    color: inherit;
  }
`;

const Menu = ({ className, items }) => (
  <FooterNav className={className}>
    {items.map(({ id, page, externalpage }) => (page || externalpage) && (
      <FooterItem key={id}>
        {externalpage ? (
          <Button link to={externalpage.externalLink}>
            {externalpage.externalTitle}
          </Button>
        ) : (
          <Button link to={page.slug}>
            {page.title}
          </Button>
        )}
      </FooterItem>
    ))}
  </FooterNav>
);

export default styled(Menu)``;
